import React from "react";
import { REGENERUS_SHIPPING_SLUG } from "@/core/urls";
import PolicyPage from "./PolicyPage";

function RegenerusShippingPolicyPage() {
  return <PolicyPage slug={REGENERUS_SHIPPING_SLUG} />;
}

export default RegenerusShippingPolicyPage;
